/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = () => css`
  width: inherit;
  height: auto;
`

export default class RightArrowIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" css={Color}>
        <g id="그룹_18449" data-name="그룹 18449" transform="translate(-14188.562 -7716.165)">
          <g id="사각형_6576" data-name="사각형 6576" transform="translate(14188.562 7716.165)" fill="none" opacity="0">
            <rect width="14" height="14" stroke="none"/>
            <rect x="0.75" y="0.75" width="12.5" height="12.5" fill="none"/>
          </g>
          <path id="패스_30455" className="fill" data-name="패스 30455"
                d="M14204.66,7727.9a.75.75,0,0,1-.53-1.28l4.47-4.47-4.47-4.47a.75.75,0,0,1,1.061-1.061l5,5a.75.75,0,0,1,0,1.061l-5,5A.747.747,0,0,1,14204.66,7727.9Z"
                transform="translate(-11.099 1.013)" fill="#798897"/>
        </g>
      </svg>
    )
  }
}
